import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useMutation } from '@apollo/react-hooks';
import { AgreementCreateMutation } from 'queries/Agreement/AgreementData';
import { notifyFailed, notifySuccess } from 'helpers/notify';
import SignWithSms from 'components/SignWithSms';

export interface AgreementData {
  contractId: string;
  clientId: string | null;
  lastName: string;
  firstName: string;
  email: string;
  mobil: string;
  city: string;
  zipCode: string;
}

interface ButtonSubmitAgreementProps {
  typ: string;
  source: string;
  data: AgreementData;
  disabled: boolean;
  onSubmit: () => void;
}

const ButtonSubmitAgreement = ({ typ, source, data, disabled, onSubmit }: ButtonSubmitAgreementProps) => {
  const [displayConformDialog, setDisplayConfirmDialog] = useState(false);

  const [agreementCreate] = useMutation(AgreementCreateMutation);

  const handleDisplayConfirmDialog = () => setDisplayConfirmDialog((prev) => !prev);

  const handleSubmitAgreement = (signature: GQL.ISignature) => {
    agreementCreate({
      variables: {
        data: {
          contractId: data.contractId,
          clientId: data.clientId,
          signatureId: signature?.id || null,
          typ,
          source,
          prijmeni: data.lastName,
          jmeno: data.firstName,
          email: data.email,
          telefon: data.mobil,
          mesto: data.city,
          psc: data.zipCode,
        },
      },
    })
      .then((result) => result.data.agreementCreate)
      .then(() => {
        // notifikace
        notifySuccess('Súhlas bol úspešne uložený');
        // potvrzení uložení souhlasu
        onSubmit();
      })
      .catch(() => {
        notifyFailed('Súhlas sa nepodarilo uložiť, prosím zopakujte akciu neskôr');
      });
  };

  return (
    <>
      {displayConformDialog && (
        <SignWithSms
          title="SMS autorizácia"
          labelSignFor="autorizáciu"
          labelSubmit="Autorizovať"
          phone={data.mobil}
          onClose={handleDisplayConfirmDialog}
          onSubmit={handleSubmitAgreement}
        />
      )}
      <Button variant="danger" disabled={disabled} size="sm" onClick={handleDisplayConfirmDialog}>
        Udeľujem súhlas
      </Button>
    </>
  );
};

export default ButtonSubmitAgreement;
